import React, { useContext } from 'react';
import UserInfoContext from '../../../utils/userInfoContext';
import { formatTimestamp } from '../../../hooks/utils';
import { PRIVACY_PAGE_PATH } from '../../../utils/privacyPage';
import { getOptInPrivacyUrl } from '../../../utils/optInGate';

const Footer = ({ isEditor = false }) => {
  const tlb = window?.objInit?.tlb;
  const { userInfoData } = useContext(UserInfoContext);

  return (
    <footer className={`footer ${!isEditor ? '' : ''}`} >
      {
        tlb == undefined ?
          <div className="panel-footer text-center ng-scope">
            On {userInfoData?.tos_accepted_date ? (
              <>
                <span id="ppAcceptanceDate">
                  {userInfoData.tos_accepted_date.includes(' @ ')
                    ? userInfoData.tos_accepted_date
                    : formatTimestamp(userInfoData.tos_accepted_date)}
                </span>
              </>
            ) : null} you accepted our <a className='f-clr-ch' href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>. You act as the data controller for all content and any related processing of personal data. <br/> BOX Ventures LLC, operating Kinetizine, acts solely as the data processor. &nbsp;
            <span>
              <a className="privacy f-clr-ch" href={PRIVACY_PAGE_PATH} target="_blank" rel="noopener noreferrer">Privacy</a> © BOX Ventures LLC. All rights reserved.
            </span>
          </div> :
          <div className='panel-footer text-center ng-scope'>
              The sender acts as the data controller and is solely responsible for the published content and any related processing of your personal data. <br/> This experience is delivered via Kinetizine by BOX Ventures LLC, acting as the data processor.  <a className="privacy f-clr-ch" href={getOptInPrivacyUrl(tlb)} target="_blank" rel="noopener noreferrer">Privacy Notice</a> © BOX Ventures LLC. All rights reserved.
            </div>
      }

    </footer>
  );
};

export default Footer;
